export default "__VITE_ASSET__BuP2KST5__"